import React from "react";
import { FileText, FileSpreadsheet, File, FileType, FileCode, Image as ImageIcon } from "lucide-react";

// Colour + icon per file kind — used on both /admin/documents and contact detail
export const KIND_META = {
  pdf:   { label: "PDF",   Icon: FileType,        color: "text-red-300",     bg: "bg-red-500/10 border-red-500/30" },
  word:  { label: "Word",  Icon: FileText,        color: "text-blue-300",    bg: "bg-blue-500/10 border-blue-500/30" },
  excel: { label: "Excel", Icon: FileSpreadsheet, color: "text-emerald-300", bg: "bg-emerald-500/10 border-emerald-500/30" },
  csv:   { label: "CSV",   Icon: FileSpreadsheet, color: "text-nex-gold",    bg: "bg-nex-gold/10 border-nex-gold/30" },
  text:  { label: "Text",  Icon: FileCode,        color: "text-nex-chrome",  bg: "bg-white/5 border-white/10" },
  image: { label: "Image", Icon: ImageIcon,       color: "text-fuchsia-300", bg: "bg-fuchsia-500/10 border-fuchsia-500/30" },
};

// Invoice/bill status tags — turns the Doc Center into a lightweight AP tracker
export const STATUS_META = {
  none:     { label: "No status",       color: "text-nex-muted",    bg: "bg-white/5 border-nex-border" },
  pending:  { label: "Pending Payment", color: "text-nex-gold",     bg: "bg-nex-gold/10 border-nex-gold/40" },
  paid:     { label: "Paid",            color: "text-emerald-300",  bg: "bg-emerald-500/10 border-emerald-500/40" },
  disputed: { label: "Disputed",        color: "text-red-300",      bg: "bg-red-500/10 border-red-500/40" },
};

export const KindIcon = ({ kind, size = 20 }) => {
  const m = KIND_META[kind] || { Icon: File, color: "text-nex-chrome", bg: "bg-white/5 border-white/10" };
  const { Icon } = m;
  return (
    <div className={`w-10 h-10 flex items-center justify-center border ${m.bg} ${m.color}`}>
      <Icon size={size} />
    </div>
  );
};

export const KindBadge = ({ kind }) => {
  const m = KIND_META[kind] || { label: kind, color: "text-nex-chrome", bg: "bg-white/5 border-white/10" };
  return (
    <span className={`mono-body text-[10px] tracking-[0.15em] uppercase px-2 py-1 border ${m.bg} ${m.color}`}>
      {m.label}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const s = STATUS_META[status] || STATUS_META.none;
  if (status === "none" || !status) return null;
  return (
    <span className={`mono-body text-[10px] tracking-[0.15em] uppercase px-2 py-1 border ${s.bg} ${s.color}`}>
      {s.label}
    </span>
  );
};

export const fmtBytes = (n) => {
  if (!n) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1_048_576) return `${(n/1024).toFixed(1)} KB`;
  return `${(n/1_048_576).toFixed(1)} MB`;
};
